<template>
  <div>
    <Modal
      :is-open="!orderOnboardingDone && !isCartDisabled"
      :cta-label="ctaLabel"
      :show-close-button="false"
      persistent
      @cta-click="ctaClicked"
    >
      <template slot="content">
        <div class="onboarding-content">
          <!-- Language selector button positioned absolutely -->
          <div class="language-selector-container">
            <v-btn
              icon
              :ripple="false"
              class="language-button"
              @click="openLanguageSelector"
            >
              <img :src="languageImage" style="width: 22px" />
            </v-btn>
          </div>
          <v-item-group v-model="onboardingSteps" mandatory>
            <v-window v-model="stepIndex">
              <v-window-item v-for="step in onboardingSteps" :key="step.id">
                <v-img
                  aspect-ratio="1"
                  contain
                  :lazy-src="step.image"
                  :src="step.image"
                  :transition="false"
                  height="200px"
                />
                <div class="tp-text-subtitle-semibold pt-7">
                  {{ $t(step.title) }}
                </div>
                <div class="tp-text-body black--text pt-4">
                  {{ $t(step.description) }}
                </div>
              </v-window-item>
            </v-window>
          </v-item-group>

          <div v-if="onboardingSteps.length > 1" class="pt-7 pb-3">
            <v-row align="center" justify="center">
              <v-item-group v-model="stepIndex">
                <v-item
                  v-for="n in onboardingSteps.length"
                  :key="n"
                  v-slot="{ active, toggle }"
                >
                  <v-btn :input-value="active" icon x-small @click="toggle">
                    <v-icon x-small>mdi-record</v-icon>
                  </v-btn>
                </v-item>
              </v-item-group>
            </v-row>
          </div>
        </div>
      </template>
    </Modal>

    <!-- Language selector modal - positioned outside Modal to ensure ref is always available -->
    <LocaleSelector
      ref="languageSelectorInOnboarding"
      :language-list="languageList"
      :selected-language="currentLocale"
      @changeLanguage="changeLanguage"
    />
  </div>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import LocaleSelector from '@/components/AgnosticLocaleSelector.vue';

export default {
  components: {
    Modal,
    LocaleSelector,
  },
  data() {
    return {
      stepIndex: 0,
      length: 1,
      stepsDone: false,
      onboardingSteps: [
        {
          id: 1,
          title: 'components.onboarding.foodCourt.step1.title',
          description: 'components.onboarding.foodCourt.step1.description',
          image:
            'https://cdn.greet.menu/food-courts-onboarding/multiMerchantOrders.png',
        },
      ],
    };
  },
  computed: {
    orderOnboardingDone() {
      return this.$store.getters.foodCourtOnboardingDone;
    },
    ctaLabel() {
      return this.$i18n.translate(
        this.stepIndex === this.onboardingSteps.length - 1
          ? 'generic.understood'
          : 'generic.next'
      );
    },
    currentLocale() {
      return this.$i18n.locale();
    },
    languageImage() {
      const code = this.$i18n.locale();
      return require(`@/assets/images/flags/${code}.svg`);
    },
    languageList() {
      const languages = this.$store.getters.getFoodCourtLanguages || [];
      const defaultLanguage = this.$store.getters.getFoodCourtDefaultLanguage;
      return [...languages, defaultLanguage] || [];
    },
    foodCourtHash() {
      return (
        this.$route.params.foodCourtHash ||
        this.$store.getters.getFoodCourtHash ||
        this.$store.getters.restaurantFoodCourtHash
      );
    },
    isCartDisabled() {
      return this.$store.getters.getIsFoodCourtSettingEnabled('disable-cart');
    },
  },
  methods: {
    ctaClicked() {
      if (this.stepIndex === this.onboardingSteps.length - 1) {
        this.$store.dispatch('setFoodCourtOnboardingDone');
      } else {
        this.stepIndex++;
      }
    },
    openLanguageSelector() {
      this.$refs.languageSelectorInOnboarding.open();
    },
    async changeLanguage(language) {
      const translations = (await import(`../../i18n/${language.code}.json`))
        .default;

      this.$i18n.add(language.code, translations);
      this.$i18n.set(language.code);

      this.$store.dispatch('fetchFoodCourtTranslations', {
        hash: this.foodCourtHash,
        languageCode: language.code,
      });
      this.$store.dispatch('setSelectedLanguage', language.code);
      this.$store.dispatch('updateFoodCourtSessionLanguage', {
        languageCode: language.code,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.language-selector-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 8px;
}

.language-button {
  background-color: rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition: background-color 100ms ease-in-out;

  &:hover {
    background-color: rgba(255, 255, 255, 1) !important;
  }
}
</style>
